export const translations = {
  en: {
    appName: "Enasuspro® Carbon Ledger",
    tagline: "ISO 14064 & GHG Protocol carbon accounting — by Enasuspro® Sustainability Coaching",
    poweredBy: "Powered by Enasuspro® Sustainability Coaching",
    login: "Log in",
    register: "Create account",
    logout: "Log out",
    email: "Email address",
    password: "Password",
    name: "Full name",
    organization: "Organization",
    dashboard: "Dashboard",
    scope1: "Scope 1",
    scope2: "Scope 2",
    scope3: "Scope 3",
    factors: "Emission Factors",
    report: "ISO Report",
    settings: "Organization",
    totalEmissions: "Total GHG Emissions",
    tCO2e: "tCO₂e",
    kgCO2e: "kgCO₂e",
    directEmissions: "Direct emissions",
    energyIndirect: "Energy indirect",
    otherIndirect: "Other indirect (value chain)",
    addEntry: "Add activity",
    activityData: "Activity data",
    emissionFactor: "Emission factor",
    category: "Category",
    date: "Date",
    facility: "Facility (optional)",
    notes: "Notes",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    exportCsv: "Export CSV",
    exportPdf: "Export PDF (ISO 14064)",
    noEntries: "No activity records yet. Add your first one.",
    search: "Search factors…",
    scope: "Scope",
    factor: "Factor",
    unit: "Unit",
    source: "Source",
    value: "Value",
    emissions: "Emissions",
    breakdownByScope: "Breakdown by Scope",
    breakdownByCategory: "Top emitting categories",
    monthlyTrend: "Monthly trend",
    orgName: "Organization name",
    reportingYear: "Reporting year",
    baseYear: "Base year",
    country: "Country / Region",
    industry: "Industry",
    orgDescription: "Description",
    saveOrg: "Save organization",
    orgSaved: "Organization saved",
    createAccount: "Create your account",
    welcomeBack: "Welcome back",
    dontHaveAccount: "Don't have an account?",
    haveAccount: "Already have an account?",
    signIn: "Sign in",
    signUp: "Sign up",
    entryAdded: "Activity saved",
    entryDeleted: "Entry removed",
    year: "Year",
    all: "All",
    records: "records",
    scopeDescS1: "Direct GHG emissions from sources owned or controlled by the organization (combustion, fugitives, process).",
    scopeDescS2: "Indirect GHG emissions from generation of purchased electricity, heat, steam and cooling.",
    scopeDescS3: "All other indirect emissions in the value chain — 15 GHG Protocol categories.",
    getStarted: "Get started",
    heroHeadline: "Measure. Report. Reduce.",
    heroSub: "A precise carbon accounting workspace built on ISO 14064-1 and the GHG Protocol Corporate Standard.",
    method: "Methodology",
    methodBody: "Emissions = Activity Data × Emission Factor. Factors from IPCC, DEFRA 2023 and IEA.",
    // v1.1
    targets: "Targets",
    team: "Team",
    import: "Import",
    dataQuality: "Data Quality",
    primary: "Primary (measured)",
    secondary: "Secondary (industry avg.)",
    tertiary: "Tertiary (proxy)",
    estimated: "Estimated",
    newTarget: "New target",
    targetName: "Target name",
    baselineYear: "Baseline year",
    targetYear: "Target year",
    reductionPct: "Reduction (%)",
    scopesCovered: "Scopes covered",
    targetType: "Target type",
    absolute: "Absolute",
    intensity: "Intensity",
    onTrack: "On track",
    offTrack: "Off track",
    baseline: "Baseline",
    current: "Current",
    target: "Target",
    progress: "Progress",
    createTarget: "Create target",
    noTargets: "No targets set. Add a science-based target to track your net-zero path.",
    sbtiAligned: "SBTi-aligned reduction pathway",
    yoyComparison: "Year-over-year comparison",
    inviteMember: "Invite member",
    invite: "Invite",
    role: "Role",
    owner: "Owner",
    editor: "Editor",
    viewer: "Viewer",
    pending: "Pending",
    active: "Active",
    remove: "Remove",
    newFactor: "New custom factor",
    factorValue: "Factor value (kgCO₂e/unit)",
    addCustomFactor: "Add custom factor",
    customFactor: "Custom",
    importTitle: "Bulk CSV import",
    downloadTemplate: "Download template",
    chooseFile: "Choose CSV file",
    preview: "Preview",
    importNow: "Import now",
    dryRun: "Dry run",
    rowsInserted: "rows inserted",
    rowsFailed: "rows failed",
    annualRequired: "Annual reduction required",
    memberAdded: "Member added",
    memberInvited: "Invitation queued (user will join upon registration)",
    memberRemoved: "Member removed",
    targetCreated: "Target created",
    targetDeleted: "Target removed",
    factorCreated: "Custom factor added",
    factorDeleted: "Factor removed",
    // v1.2
    organizations: "Organizations",
    intensity: "Intensity",
    verification: "Verification",
    newOrg: "New organization",
    createOrg: "Create organization",
    switchOrg: "Switch",
    activeOrg: "Active organization",
    orgs: "organizations",
    orgCreated: "Organization created",
    intensityData: "Intensity data",
    revenue: "Revenue",
    currency: "Currency",
    fte: "FTE headcount",
    floorArea: "Floor area (m²)",
    productionUnits: "Production units",
    productionUnitName: "Production unit label",
    saveIntensity: "Save",
    intensitySaved: "Intensity data saved",
    perRevenue: "per revenue",
    perFte: "per FTE",
    perArea: "per m²",
    perProduction: "per production unit",
    intensityNoData: "No intensity data for this year. Add revenue, FTE or floor area to compute intensity ratios.",
    submitForVerification: "Submit for verification",
    verificationStatus: "Verification status",
    unverified: "Unverified",
    inReview: "In review",
    verified: "Verified",
    qualified: "Qualified",
    adverse: "Adverse",
    verifierOnly: "Only users with verifier role can issue verification opinions",
    verifierDecision: "Verifier decision",
    opinion: "Opinion",
    levelOfAssurance: "Level of assurance",
    limited: "Limited",
    reasonable: "Reasonable",
    issueOpinion: "Issue opinion",
    verifier: "Verifier",
    verificationSubmitted: "Submitted for verification",
    verificationDecided: "Verification decision recorded",
    verifiedBy: "Verified by",
    onDate: "on",
    iso14064_3: "ISO 14064-3 assurance",
    // v1.3
    facilities: "Facilities",
    newFacility: "New facility",
    createFacility: "Create facility",
    facilityName: "Facility name",
    facilityCode: "Code",
    facilityType: "Type",
    parentFacility: "Parent (optional)",
    address: "Address",
    facilityCreated: "Facility created",
    facilityDeleted: "Facility removed",
    noFacilities: "No facilities yet. Add offices, plants or warehouses to break down emissions by site.",
    facility: "Facility",
    unassigned: "Unassigned",
    breakdownByFacility: "Breakdown by facility",
    jobs: "Jobs",
    jobsDesc: "Background imports and exports run here so large files don't block your workflow.",
    noJobs: "No background jobs yet.",
    queueImport: "Queue import",
    generatePdfAsync: "Generate PDF (async)",
    absoluteTarget: "Absolute",
    intensityRevenue: "Intensity — per revenue",
    intensityFte: "Intensity — per FTE",
    intensityArea: "Intensity — per m²",
    netZero: "Net-zero",
    residual: "Residual (%)",
    residualHint: "For net-zero: max residual emissions permitted (offset outside boundary)",
    notComputable: "Intensity denominator missing for baseline year",
    // v1.4
    approvals: "Approvals",
    approvalsDesc: "Owners review entries submitted by editors before they hit the inventory.",
    pendingApproval: "Pending approval",
    noPending: "No entries waiting for approval. Nice work!",
    approve: "Approve",
    reject: "Reject",
    rejectReason: "Reason (optional)",
    rejectConfirm: "Reject entry",
    approved: "Approved",
    rejected: "Rejected",
    submittedBy: "Submitted by",
    submittedOn: "Submitted",
    approvedToast: "Entry approved",
    rejectedToast: "Entry rejected",
    facilityFilter: "Facility",
    allFacilities: "All facilities",
    pendingBadge: "pending",
    approvalRequired: "This entry is pending owner approval",
    // v1.5
    selectAll: "Select all",
    selected: "selected",
    bulkApprove: "Approve selected",
    bulkReject: "Reject selected",
    bulkApproved: "Selected entries approved",
    bulkRejected: "Selected entries rejected",
    orgWide: "Organization-wide",
    perFacility: "Per facility",
    targetScope: "Target scope",
    facilityFilterLabel: "Facility filter",
    // v1.8 — CBAM
    cbam: "CBAM",
    cbamTitle: "Carbon Border Adjustment Mechanism",
    cbamDesc: "Calculate CBAM certificate liability for imports of cement, iron & steel, aluminum, fertilizers, electricity and hydrogen into the EU. Applies EU Regulation 2023/956 phase-in schedule (2026 → 2034).",
    cbamAddImport: "Add import declaration",
    cbamProduct: "Product category",
    cbamCnCode: "CN code",
    cbamQuantity: "Quantity",
    cbamCountry: "Country of origin",
    cbamDirectOverride: "Direct emissions override",
    cbamIndirectOverride: "Indirect emissions override",
    cbamOriginPrice: "Carbon price paid at origin",
    cbamEtsPrice: "EU ETS price",
    cbamEtsPriceTitle: "EU ETS certificate price",
    cbamEtsPriceHint: "Set the EU ETS carbon price used to value embedded emissions. Update quarterly as EU allowance auction prices shift. Owners only.",
    cbamPayable: "CBAM liability",
    cbamEmbedded: "Embedded emissions",
    cbamGross: "Gross",
    cbamOriginCredit: "Origin carbon credit",
    cbamOriginCreditHint: "Deduction for carbon price already paid in the exporting country.",
    cbamPreview: "Live calculation",
    cbamDeclarations: "Import declarations",
    cbamNoImports: "No CBAM declarations yet. Add your first import to compute liability.",
    cbamByProduct: "Liability by product",
    cbamByCountry: "Liability by country of origin",
    cbamPhaseInSchedule: "CBAM phase-in schedule (% of embedded emissions payable)",
    cbamImportAdded: "Declaration added",
    cbamImportDeleted: "Declaration removed",
    cbamPriceUpdated: "EU ETS price updated",
    declarations: "declarations",
    phaseIn: "phase-in",
    productDescription: "Product description",
    default: "default",
    // v1.8 — Carbon Tax
    carbonTax: "Carbon Tax",
    carbonTaxTitle: "Global Carbon Tax Simulator",
    carbonTaxDesc: "Apply carbon tax rates from 12 jurisdictions to your organisation's approved Scope 1/2/3 emissions and estimate your exposure. Useful for scenario planning and export-market cost modelling.",
    ctSelectJurisdiction: "Select jurisdiction",
    ctJurisdiction: "Jurisdiction",
    ctRegion: "Region",
    ctPrice: "Price €/tCO₂e",
    ctPriceUsed: "Price applied",
    ctCustomPrice: "Override price (€)",
    ctType: "Type",
    ctScopeCoverage: "Scope coverage",
    ctEstimatedTax: "Estimated tax liability",
    ctCovered: "Covered emissions",
    ctBreakdownByScope: "Breakdown by scope",
    ctApplies: "Applies",
    ctYes: "Yes",
    ctNo: "No",
    ctTaxEur: "Tax (€)",
    ctCompareAll: "Compare across all jurisdictions",
    total: "Total",
    gross: "Gross",
    // v1.8 — ESRS
    esrs: "ESRS",
    esrsTitle: "ESRS Sustainability Disclosures",
    esrsDesc: "European Sustainability Reporting Standards under CSRD. E1 (climate) is auto-generated from your approved GHG data; E2/E3/E5 provide qualitative disclosure templates aligned with EFRAG XBRL taxonomy.",
    esrsE1_1: "Transition plan",
    esrsE1_4: "Climate change mitigation targets",
    esrsE1_5: "Energy consumption & intensity",
    esrsE1_6: "Gross GHG emissions",
    esrsE1_7: "GHG removals & offsets",
    esrsTitle_E2: "Pollution",
    esrsTitle_E3: "Water & Marine Resources",
    esrsTitle_E4: "Biodiversity & Ecosystems",
    esrsTitle_E5: "Resource use & Circular economy",
    esrsTitle_S1: "Own Workforce",
    esrsTitle_S2: "Workers in the Value Chain",
    esrsTitle_S3: "Affected Communities",
    esrsTitle_S4: "Consumers & End-users",
    esrsTitle_G1: "Business Conduct",
    esrsConsolidation: "Consolidation approach",
    esrsProtocol: "Standard / Protocol",
    esrsReportingYear: "Reporting year",
    esrsRecords: "Activity records",
    esrsBiogenic: "Biogenic (out-of-scope)",
    esrsNoTargets: "No science-based targets set for this org. Add one under Targets.",
    esrsEnergyIntensity: "Energy/emission intensity",
    esrsSaved: "Disclosures saved",
    esrsLastSaved: "Last saved",
    esrsWriteDisclosure: "Enter your disclosure narrative here…",
    // v1.9 — Quarterly + PDF
    cbamQuarter: "Quarter",
    cbamDownloadPdf: "Download quarterly PDF",
    cbamSelectQuarter: "Select a quarter first (Q1–Q4)",
    esrsDownloadPdf: "Download ESRS PDF",
    // v1.9 — Clients portal
    clientsNav: "Clients",
    clientsTitle: "Client Portfolio",
    clientsDesc: "Portfolio-level view across every organization you advise. Track onboarding progress, current-year emissions, and pending approvals for each client — all from one dashboard.",
    clientsAddNew: "Onboard new client",
    clientsCount: "Clients",
    clientsFullyOnboarded: "Fully onboarded",
    clientsTotalEmissions: "Portfolio emissions",
    clientsPending: "Pending",
    clientsList: "Client organizations",
    clientsEmpty: "No client organizations yet. Onboard your first client to get started.",
    clientsOnboarding: "Onboarding",
    clientsNewTitle: "Onboard a new client",
    clientsOrgName: "Client organization name",
    clientsInviteOptional: "Client user invitation (optional)",
    clientsCreate: "Create client",
    clientsCreated: "Client organization created",
    clientCreated: "Client organization created",
    clientsInviteReady: "Invitation ready",
    clientsInviteHint: "Share these credentials with your client so they can log in. They should change the password on first login.",
    scope123: "Total emissions",
    reportingYear: "Reporting year",
    industry: "Industry",
    country: "Country",
    name: "Name",
    email: "Email",
    close: "Close",
    // v2.0 — XML export + Glossary
    cbamDownloadXml: "Download XML (EU Registry)",
    glossaryNav: "Glossary",
    glossaryTitle: "Abbreviations & Terms",
    glossaryDesc: "Every acronym, standard and technical term used across the Enasuspro® Carbon Ledger platform, with plain-language explanations in Turkish and English. Ideal for onboarding new team members, briefing auditors, or educating clients.",
    glossarySearch: "Search term or definition…",
    glossaryEntries: "entries",
    glossaryNoResults: "No entries match your search.",
    // v2.1 — GRI
    gri: "GRI",
    griTitle: "GRI Sustainability Reporting",
    griDesc: "Global Reporting Initiative Standards (2021 update) — the most widely-used sustainability reporting framework worldwide. Covers Universal (GRI 2), Economic (200), Environmental (300), and Social (400) topic-specific standards. Complements ESRS/CSRD for stakeholders outside the EU.",
    griNoDatapoints: "No datapoints in this standard.",
    // v2.2 — Google Auth + JSON/CSV exports
    or: "or",
    signInWithGoogle: "Sign in with Google",
    cbamDownloadJson: "Download JSON",
    cbamDownloadCsv: "Download CSV",
    // v2.3 — XBRL + API docs + Blog
    esrsDownloadXbrl: "Download XBRL",
    apiDocsNav: "API",
    apiDocsTitle: "Developer API",
    apiDocsDesc: "REST endpoints for programmatic access to the platform. All requests require JWT + X-Org-Id. Full auto-generated Swagger UI + ReDoc + OpenAPI JSON available.",
    apiDocsSwaggerDesc: "Interactive documentation with try-it-out functionality — powered by FastAPI's built-in OpenAPI schema.",
    apiDocsOpenSwagger: "Open Swagger UI",
    apiDocsAuth: "Authentication",
    apiDocsAuthHint: "Include these headers on every authenticated request:",
    // v2.4 — Trends
    trendsNav: "Trends",
    trendsTitle: "Multi-Year Emissions Trends",
    trendsDesc: "Year-over-year comparison of Scope 1, 2 and 3 emissions with baseline and CAGR. Overlay your SBTi target trajectory to see whether you're on track.",
    trendBaseline: "Baseline",
    trendLatest: "Latest",
    trendTotalChange: "Total change",
    trendYears: "years",
    trendByScope: "Emissions by scope, per year",
    trendVsTarget: "Actual vs SBTi target trajectory",
    trendActual: "Actual",
    trendTargetPath: "Target path",
    trendTable: "Yearly breakdown",
    trendNoData: "Add emission entries across multiple years to see trend charts.",

  },
  tr: {
    appName: "Enasuspro® Carbon Ledger",
    tagline: "ISO 14064 ve GHG Protokolü karbon muhasebesi — Enasuspro® Sustainability Coaching",
    poweredBy: "Enasuspro® Sustainability Coaching tarafından sunulmaktadır",
    login: "Giriş yap",
    register: "Hesap oluştur",
    logout: "Çıkış",
    email: "E-posta adresi",
    password: "Şifre",
    name: "Ad soyad",
    organization: "Kuruluş",
    dashboard: "Panel",
    scope1: "Kapsam 1",
    scope2: "Kapsam 2",
    scope3: "Kapsam 3",
    factors: "Emisyon Faktörleri",
    report: "ISO Raporu",
    settings: "Kuruluş",
    totalEmissions: "Toplam Sera Gazı",
    tCO2e: "tCO₂e",
    kgCO2e: "kgCO₂e",
    directEmissions: "Doğrudan emisyonlar",
    energyIndirect: "Enerji dolaylı",
    otherIndirect: "Diğer dolaylı (değer zinciri)",
    addEntry: "Aktivite ekle",
    activityData: "Aktivite verisi",
    emissionFactor: "Emisyon faktörü",
    category: "Kategori",
    date: "Tarih",
    facility: "Tesis (opsiyonel)",
    notes: "Notlar",
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    exportCsv: "CSV Dışa Aktar",
    exportPdf: "PDF Dışa Aktar (ISO 14064)",
    noEntries: "Henüz aktivite kaydı yok. İlkini ekleyin.",
    search: "Faktör ara…",
    scope: "Kapsam",
    factor: "Faktör",
    unit: "Birim",
    source: "Kaynak",
    value: "Değer",
    emissions: "Emisyon",
    breakdownByScope: "Kapsam Dağılımı",
    breakdownByCategory: "En yüksek kategoriler",
    monthlyTrend: "Aylık trend",
    orgName: "Kuruluş adı",
    reportingYear: "Raporlama yılı",
    baseYear: "Baz yıl",
    country: "Ülke / Bölge",
    industry: "Sektör",
    orgDescription: "Açıklama",
    saveOrg: "Kuruluşu kaydet",
    orgSaved: "Kuruluş kaydedildi",
    createAccount: "Hesabınızı oluşturun",
    welcomeBack: "Tekrar hoş geldiniz",
    dontHaveAccount: "Hesabınız yok mu?",
    haveAccount: "Zaten hesabınız var mı?",
    signIn: "Giriş yap",
    signUp: "Kaydol",
    entryAdded: "Aktivite kaydedildi",
    entryDeleted: "Kayıt silindi",
    year: "Yıl",
    all: "Tümü",
    records: "kayıt",
    scopeDescS1: "Kuruluşun sahip olduğu veya kontrol ettiği kaynaklardan doğrudan sera gazı emisyonları (yanma, kaçak, süreç).",
    scopeDescS2: "Satın alınan elektrik, ısı, buhar ve soğutmanın üretiminden kaynaklanan dolaylı emisyonlar.",
    scopeDescS3: "Değer zincirindeki diğer tüm dolaylı emisyonlar — 15 GHG Protokolü kategorisi.",
    getStarted: "Başlayın",
    heroHeadline: "Ölç. Raporla. Azalt.",
    heroSub: "ISO 14064-1 ve GHG Protokolü Kurumsal Standardına dayalı hassas karbon muhasebesi çalışma alanı.",
    method: "Metodoloji",
    methodBody: "Emisyon = Aktivite Verisi × Emisyon Faktörü. Faktörler IPCC, DEFRA 2023 ve IEA kaynaklıdır.",
    // v1.1
    targets: "Hedefler",
    team: "Ekip",
    import: "İçe Aktar",
    dataQuality: "Veri Kalitesi",
    primary: "Birincil (ölçülmüş)",
    secondary: "İkincil (endüstri ort.)",
    tertiary: "Üçüncül (vekil)",
    estimated: "Tahmini",
    newTarget: "Yeni hedef",
    targetName: "Hedef adı",
    baselineYear: "Baz yıl",
    targetYear: "Hedef yıl",
    reductionPct: "Azaltım (%)",
    scopesCovered: "Kapsanan kapsamlar",
    targetType: "Hedef tipi",
    absolute: "Mutlak",
    intensity: "Yoğunluk",
    onTrack: "Yolunda",
    offTrack: "Geride",
    baseline: "Baz",
    current: "Güncel",
    target: "Hedef",
    progress: "İlerleme",
    createTarget: "Hedef oluştur",
    noTargets: "Henüz hedef yok. Net-sıfır yolunu izlemek için bilimsel bir hedef ekleyin.",
    sbtiAligned: "SBTi uyumlu azaltım patikası",
    yoyComparison: "Yıllar arası karşılaştırma",
    inviteMember: "Üye davet et",
    invite: "Davet et",
    role: "Rol",
    owner: "Sahip",
    editor: "Editör",
    viewer: "İzleyici",
    pending: "Beklemede",
    active: "Aktif",
    remove: "Kaldır",
    newFactor: "Yeni özel faktör",
    factorValue: "Faktör değeri (kgCO₂e/birim)",
    addCustomFactor: "Özel faktör ekle",
    customFactor: "Özel",
    importTitle: "Toplu CSV içe aktarımı",
    downloadTemplate: "Şablonu indir",
    chooseFile: "CSV dosyası seç",
    preview: "Önizleme",
    importNow: "Şimdi içe aktar",
    dryRun: "Deneme",
    rowsInserted: "satır eklendi",
    rowsFailed: "satır başarısız",
    annualRequired: "Gerekli yıllık azaltım",
    memberAdded: "Üye eklendi",
    memberInvited: "Davet oluşturuldu (kullanıcı kayıt olunca katılacak)",
    memberRemoved: "Üye kaldırıldı",
    targetCreated: "Hedef oluşturuldu",
    targetDeleted: "Hedef silindi",
    factorCreated: "Özel faktör eklendi",
    factorDeleted: "Faktör silindi",
    // v1.2
    organizations: "Kuruluşlar",
    intensity: "Yoğunluk",
    verification: "Doğrulama",
    newOrg: "Yeni kuruluş",
    createOrg: "Kuruluş oluştur",
    switchOrg: "Değiştir",
    activeOrg: "Aktif kuruluş",
    orgs: "kuruluş",
    orgCreated: "Kuruluş oluşturuldu",
    intensityData: "Yoğunluk verisi",
    revenue: "Gelir",
    currency: "Para birimi",
    fte: "Tam Zamanlı Çalışan (FTE)",
    floorArea: "Kapalı alan (m²)",
    productionUnits: "Üretim birimi",
    productionUnitName: "Üretim birim etiketi",
    saveIntensity: "Kaydet",
    intensitySaved: "Yoğunluk verisi kaydedildi",
    perRevenue: "gelir başına",
    perFte: "FTE başına",
    perArea: "m² başına",
    perProduction: "üretim birimi başına",
    intensityNoData: "Bu yıl için yoğunluk verisi yok. Yoğunluk oranlarını hesaplamak için gelir, FTE veya kapalı alan ekleyin.",
    submitForVerification: "Doğrulamaya gönder",
    verificationStatus: "Doğrulama durumu",
    unverified: "Doğrulanmamış",
    inReview: "İnceleniyor",
    verified: "Doğrulandı",
    qualified: "Şartlı",
    adverse: "Olumsuz",
    verifierOnly: "Sadece doğrulayıcı rolündeki kullanıcılar görüş yayınlayabilir",
    verifierDecision: "Doğrulayıcı kararı",
    opinion: "Görüş",
    levelOfAssurance: "Güvence düzeyi",
    limited: "Sınırlı",
    reasonable: "Makul",
    issueOpinion: "Görüş yayınla",
    verifier: "Doğrulayıcı",
    verificationSubmitted: "Doğrulamaya gönderildi",
    verificationDecided: "Doğrulama kararı kaydedildi",
    verifiedBy: "Doğrulayan",
    onDate: "tarihinde",
    iso14064_3: "ISO 14064-3 güvence",
    // v1.3
    facilities: "Tesisler",
    newFacility: "Yeni tesis",
    createFacility: "Tesis oluştur",
    facilityName: "Tesis adı",
    facilityCode: "Kod",
    facilityType: "Tip",
    parentFacility: "Üst tesis (opsiyonel)",
    address: "Adres",
    facilityCreated: "Tesis oluşturuldu",
    facilityDeleted: "Tesis silindi",
    noFacilities: "Henüz tesis yok. Emisyonları saha bazında dağıtmak için ofis, fabrika veya depo ekleyin.",
    facility: "Tesis",
    unassigned: "Atanmamış",
    breakdownByFacility: "Tesis dağılımı",
    jobs: "İşler",
    jobsDesc: "Arka plan içe/dışa aktarım işleri burada yürütülür, büyük dosyalar iş akışınızı engellemez.",
    noJobs: "Henüz arka plan işi yok.",
    queueImport: "İçe aktarımı kuyruğa al",
    generatePdfAsync: "PDF oluştur (arka plan)",
    absoluteTarget: "Mutlak",
    intensityRevenue: "Yoğunluk — gelir başına",
    intensityFte: "Yoğunluk — FTE başına",
    intensityArea: "Yoğunluk — m² başına",
    netZero: "Net sıfır",
    residual: "Kalan (%)",
    residualHint: "Net sıfır için: sınır dışı denkleştirilebilir maksimum kalan emisyon",
    notComputable: "Baz yıl için yoğunluk paydası eksik",
    // v1.4
    approvals: "Onaylar",
    approvalsDesc: "Sahipler, editörler tarafından gönderilen kayıtları envantere girmeden önce inceler.",
    pendingApproval: "Onay bekliyor",
    noPending: "Onay bekleyen kayıt yok. İyi iş!",
    approve: "Onayla",
    reject: "Reddet",
    rejectReason: "Sebep (opsiyonel)",
    rejectConfirm: "Kaydı reddet",
    approved: "Onaylandı",
    rejected: "Reddedildi",
    submittedBy: "Gönderen",
    submittedOn: "Gönderildi",
    approvedToast: "Kayıt onaylandı",
    rejectedToast: "Kayıt reddedildi",
    facilityFilter: "Tesis",
    allFacilities: "Tüm tesisler",
    pendingBadge: "bekliyor",
    approvalRequired: "Bu kayıt sahip onayı bekliyor",
    // v1.5
    selectAll: "Tümünü seç",
    selected: "seçili",
    bulkApprove: "Seçilenleri onayla",
    bulkReject: "Seçilenleri reddet",
    bulkApproved: "Seçili kayıtlar onaylandı",
    bulkRejected: "Seçili kayıtlar reddedildi",
    orgWide: "Kuruluş geneli",
    perFacility: "Tesis bazında",
    scope_all: "Tümü",
    targetScope: "Hedef kapsamı",
    duplicatesSkipped: "yinelenen atlandı",
    newThisRun: "bu çalışmada yeni",
    facilityFilterLabel: "Tesis filtresi",
    // v1.8 — CBAM
    cbam: "CBAM",
    cbamTitle: "Sınırda Karbon Düzenleme Mekanizması",
    cbamDesc: "Çimento, demir-çelik, alüminyum, gübre, elektrik ve hidrojen ithalatları için AB'ye giriş sırasındaki CBAM sertifika yükümlülüğünüzü hesaplayın. AB 2023/956 sayılı Tüzüğün 2026 → 2034 kademeli geçiş takvimini uygular.",
    cbamAddImport: "İthalat beyanı ekle",
    cbamProduct: "Ürün kategorisi",
    cbamCnCode: "CN kodu",
    cbamQuantity: "Miktar",
    cbamCountry: "Menşe ülke",
    cbamDirectOverride: "Doğrudan emisyon (özel değer)",
    cbamIndirectOverride: "Dolaylı emisyon (özel değer)",
    cbamOriginPrice: "Menşe ülkede ödenmiş karbon fiyatı",
    cbamEtsPrice: "AB ETS fiyatı",
    cbamEtsPriceTitle: "AB ETS sertifika fiyatı",
    cbamEtsPriceHint: "Gömülü emisyonları değerlemek için kullanılan AB ETS karbon fiyatını belirleyin. AB tahsisat açık artırma fiyatları değiştikçe çeyreklik olarak güncelleyin. Sadece sahip.",
    cbamPayable: "CBAM ödenecek",
    cbamEmbedded: "Gömülü emisyon",
    cbamGross: "Brüt",
    cbamOriginCredit: "Menşe karbon kredisi",
    cbamOriginCreditHint: "İhracatçı ülkede zaten ödenmiş karbon fiyatı için düşüm.",
    cbamPreview: "Anlık hesaplama",
    cbamDeclarations: "İthalat beyanları",
    cbamNoImports: "Henüz CBAM beyanı yok. Yükümlülüğü hesaplamak için ilk ithalatınızı ekleyin.",
    cbamByProduct: "Ürüne göre yükümlülük",
    cbamByCountry: "Menşe ülkeye göre yükümlülük",
    cbamPhaseInSchedule: "CBAM kademeli geçiş takvimi (ödenecek gömülü emisyon oranı)",
    cbamImportAdded: "Beyan eklendi",
    cbamImportDeleted: "Beyan silindi",
    cbamPriceUpdated: "AB ETS fiyatı güncellendi",
    declarations: "beyan",
    phaseIn: "kademeli",
    productDescription: "Ürün açıklaması",
    default: "varsayılan",
    // v1.8 — Carbon Tax
    carbonTax: "Karbon Vergisi",
    carbonTaxTitle: "Küresel Karbon Vergisi Simülatörü",
    carbonTaxDesc: "12 farklı jurisdiction'ın karbon vergi oranlarını kuruluşunuzun onaylı Kapsam 1/2/3 emisyonlarına uygulayarak potansiyel vergi yükünüzü tahmin edin. Senaryo planlaması ve ihracat pazarı maliyet modellemesi için idealdir.",
    ctSelectJurisdiction: "Jurisdiction seç",
    ctJurisdiction: "Jurisdiction",
    ctRegion: "Bölge",
    ctPrice: "Fiyat €/tCO₂e",
    ctPriceUsed: "Uygulanan fiyat",
    ctCustomPrice: "Özel fiyat (€)",
    ctType: "Tip",
    ctScopeCoverage: "Kapsam kapsamı",
    ctEstimatedTax: "Tahmini vergi yükü",
    ctCovered: "Kapsama giren emisyon",
    ctBreakdownByScope: "Kapsam bazında dağılım",
    ctApplies: "Uygulanır",
    ctYes: "Evet",
    ctNo: "Hayır",
    ctTaxEur: "Vergi (€)",
    ctCompareAll: "Tüm jurisdiction'ları karşılaştır",
    total: "Toplam",
    gross: "Brüt",
    // v1.8 — ESRS
    esrs: "ESRS",
    esrsTitle: "ESRS Sürdürülebilirlik Açıklamaları",
    esrsDesc: "CSRD kapsamında Avrupa Sürdürülebilirlik Raporlama Standartları. E1 (iklim) onaylı GHG verilerinizden otomatik oluşturulur; E2/E3/E5 için EFRAG XBRL taksonomisiyle uyumlu nitel açıklama şablonları sunulur.",
    esrsE1_1: "Geçiş planı",
    esrsE1_4: "İklim değişikliği azaltım hedefleri",
    esrsE1_5: "Enerji tüketimi ve yoğunluğu",
    esrsE1_6: "Brüt sera gazı emisyonları",
    esrsE1_7: "GHG uzaklaştırma ve denkleştirme",
    esrsTitle_E2: "Kirlilik",
    esrsTitle_E3: "Su ve Deniz Kaynakları",
    esrsTitle_E4: "Biyoçeşitlilik ve Ekosistemler",
    esrsTitle_E5: "Kaynak kullanımı ve Döngüsel ekonomi",
    esrsTitle_S1: "Kendi İşgücü",
    esrsTitle_S2: "Değer Zinciri Çalışanları",
    esrsTitle_S3: "Etkilenen Topluluklar",
    esrsTitle_S4: "Tüketiciler ve Son Kullanıcılar",
    esrsTitle_G1: "İş Etiği ve Yönetişim",
    esrsConsolidation: "Konsolidasyon yaklaşımı",
    esrsProtocol: "Standart / Protokol",
    esrsReportingYear: "Raporlama yılı",
    esrsRecords: "Aktivite kaydı",
    esrsBiogenic: "Biyojenik (kapsam dışı)",
    esrsNoTargets: "Bu kuruluş için bilimsel hedef tanımlanmamış. Hedefler sayfasından ekleyin.",
    esrsEnergyIntensity: "Enerji/emisyon yoğunluğu",
    esrsSaved: "Açıklamalar kaydedildi",
    esrsLastSaved: "Son kayıt",
    esrsWriteDisclosure: "Açıklama metninizi buraya yazın…",
    // v1.9 — Quarterly + PDF
    cbamQuarter: "Çeyrek",
    cbamDownloadPdf: "Çeyreklik PDF indir",
    cbamSelectQuarter: "Önce bir çeyrek seçin (Q1–Q4)",
    esrsDownloadPdf: "ESRS PDF indir",
    // v1.9 — Clients portal
    clientsNav: "Müşteriler",
    clientsTitle: "Müşteri Portföyü",
    clientsDesc: "Danışmanlığını yaptığınız tüm kuruluşlar için portföy düzeyinde bakış. Her müşteri için onboarding ilerlemesi, yıllık emisyonlar ve bekleyen onayları tek panelden takip edin.",
    clientsAddNew: "Yeni müşteri onboarding'i",
    clientsCount: "Müşteri",
    clientsFullyOnboarded: "Tam onboard",
    clientsTotalEmissions: "Portföy emisyonu",
    clientsPending: "Bekleyen",
    clientsList: "Müşteri kuruluşları",
    clientsEmpty: "Henüz müşteri kuruluşu yok. İlk müşterinizi ekleyerek başlayın.",
    clientsOnboarding: "Onboarding",
    clientsNewTitle: "Yeni müşteri onboard et",
    clientsOrgName: "Müşteri kuruluş adı",
    clientsInviteOptional: "Müşteri kullanıcı daveti (isteğe bağlı)",
    clientsCreate: "Müşteri oluştur",
    clientsCreated: "Müşteri kuruluşu oluşturuldu",
    clientCreated: "Müşteri kuruluşu oluşturuldu",
    clientsInviteReady: "Davet hazır",
    clientsInviteHint: "Bu bilgileri müşterinizle paylaşın; ilk girişte parolayı değiştirmelidirler.",
    scope123: "Toplam emisyon",
    reportingYear: "Raporlama yılı",
    industry: "Sektör",
    country: "Ülke",
    name: "Ad",
    email: "E-posta",
    close: "Kapat",
    // v2.0 — XML export + Sözlük
    cbamDownloadXml: "XML indir (AB Registry)",
    glossaryNav: "Sözlük",
    glossaryTitle: "Kısaltmalar ve Terimler",
    glossaryDesc: "Enasuspro® Carbon Ledger platformunda kullanılan tüm kısaltma, standart ve teknik terimlerin Türkçe ve İngilizce açıklamaları. Yeni ekip üyelerini yetiştirmek, denetçileri bilgilendirmek veya müşterileri eğitmek için idealdir.",
    glossarySearch: "Terim veya tanım ara…",
    glossaryEntries: "kayıt",
    glossaryNoResults: "Aramanızla eşleşen kayıt yok.",
    // v2.1 — GRI
    gri: "GRI",
    griTitle: "GRI Sürdürülebilirlik Raporlaması",
    griDesc: "Global Reporting Initiative Standartları (2021 güncellemesi) — dünya çapında en yaygın kullanılan sürdürülebilirlik raporlama çerçevesi. Evrensel (GRI 2), Ekonomik (200), Çevresel (300) ve Sosyal (400) konu bazlı standartları kapsar. AB dışındaki paydaşlar için ESRS/CSRD'yi tamamlar.",
    griNoDatapoints: "Bu standartta datapoint yok.",
    // v2.2 — Google Auth + JSON/CSV exports
    or: "veya",
    signInWithGoogle: "Google ile Giriş Yap",
    cbamDownloadJson: "JSON indir",
    cbamDownloadCsv: "CSV indir",
    // v2.3 — XBRL + API docs + Blog
    esrsDownloadXbrl: "XBRL indir",
    apiDocsNav: "API",
    apiDocsTitle: "Geliştirici API",
    apiDocsDesc: "Platforma programatik erişim için REST uç noktaları. Tüm istekler JWT + X-Org-Id gerektirir. Otomatik oluşturulan tam Swagger UI + ReDoc + OpenAPI JSON dokümantasyonu mevcut.",
    apiDocsSwaggerDesc: "FastAPI'nin yerleşik OpenAPI şemasıyla oluşturulan, dene-gör özellikli etkileşimli dokümantasyon.",
    apiDocsOpenSwagger: "Swagger UI'yı aç",
    apiDocsAuth: "Kimlik doğrulama",
    apiDocsAuthHint: "Her yetkilendirilmiş istekte şu başlıkları ekleyin:",
    // v2.4 — Trends
    trendsNav: "Trend Analizi",
    trendsTitle: "Çok Yıllı Emisyon Trendleri",
    trendsDesc: "Kapsam 1, 2 ve 3 emisyonlarının yıldan yıla karşılaştırması, baz yıl ve CAGR. SBTi hedef yörüngenizi üstüne bindirerek yolunda olup olmadığınızı görün.",
    trendBaseline: "Baz yıl",
    trendLatest: "Son yıl",
    trendTotalChange: "Toplam değişim",
    trendYears: "yıl",
    trendByScope: "Yıllara göre kapsam bazında emisyon",
    trendVsTarget: "Gerçek performans vs SBTi hedef yörüngesi",
    trendActual: "Gerçekleşen",
    trendTargetPath: "Hedef yörünge",
    trendTable: "Yıllık dağılım",
    trendNoData: "Trend grafiklerini görmek için birden fazla yıla ait emisyon kaydı ekleyin.",
  },
};
